import React, { Component } from 'react';
import CreatableSelect from 'react-select/creatable';
import axios from 'axios'
import { tx } from '@transifex/native';

const createOption = (obj) => ({
    label: obj.name,
    value: obj._id
})

const createOptions = (options) => {
    return options.map(createOption)
}

export default class NewUserCompany extends Component {
    state = {
        isLoading: false,
        options: [],
        value: undefined,
    }

    componentDidMount() {
        fetch(`${window.MYQLOCX_API}/subject/admin/companies`, {
            method: 'GET',
            headers: { ...axios.defaults.headers.common, 'Content-Type': 'application/json' },
        })
            .then(t => t.json())
            .then(json => {
                const sortedJson = json.sort((a, b) => {
                    if (a.name < b.name) return -1
                    if (a.name > b.name) return 1
                    return 0
                })
                this.setState({
                    options: createOptions(sortedJson),
                    value: this.props.preselectedCompany ? { ...this.props.preselectedCompany, value: this.props.preselectedCompany._id, label: this.props.preselectedCompany.name } : null
                })
            })
    }

    handleChange = (newValue) => {
        if (!newValue) return

        this.setState({ value: newValue })

        this.props.companySelected(newValue)
    }

    handleCreate = (inputValue) => {
        this.setState({ isLoading: true })

        fetch(`${window.MYQLOCX_API}/subject/admin/companies`, {
            method: 'POST',
            headers: { ...axios.defaults.headers.common, 'Content-Type': 'application/json' },
            body: JSON.stringify({ name: inputValue.trim() })

        })
            .then(t => t.json())
            .then(json => {
                const sortedJson = json.sort((a, b) => {
                    if (a.name < b.name) return -1
                    if (a.name > b.name) return 1
                    return 0
                })
                this.setState({ options: createOptions(sortedJson), isLoading: false }, () => { this.handleChange(createOption(json.find(j => j.name === inputValue))) })
            })
    }

    render() {
        const { isLoading, options, value } = this.state

        return (
            <CreatableSelect
                isClearable
                isDisabled={isLoading}
                isLoading={isLoading}
                onChange={this.handleChange}
                onCreateOption={this.handleCreate}
                options={options}
                value={value}
                formatCreateLabel={(inputText) => tx.translate('Create/add company "{inputText}"', { inputText })}
                placeholder={tx.translate('Select company')}
            />
        )
    }
}